import React from 'react';
import { connect } from 'react-redux';

import QuantityPicker from '../../product/components/quantity-picker';
import { withError } from '../../shared/components/error-boundary';
import { updateCart } from '../utility-actions';

import '../css/remove-btn.less';


class RemoveButton extends React.Component {

    setQuantity = (quantity) => {
        const { prdCartRecord, updateCart, product } = this.props;
        updateCart(prdCartRecord, quantity)
    }

    remove = () => {
        const { prdCartRecord, updateCart, product } = this.props;
        updateCart(prdCartRecord, "0")
    }

    render(){
        const { showSelector, product, prdCartRecord } = this.props;
        const { qty } = prdCartRecord;
        const quantityPicker = (showSelector && product.prdClass !== "CTO")
			? (
				<div className="quantity-picker-container">
					<QuantityPicker
                        quantity={qty}
                        onPick={this.setQuantity}
                        enabled={true}
                    />
				</div>
			) : null;
        return(
            <div className={`remove-btn-container`}>
                {quantityPicker}
                <div className='remove-container'>                
                    <div className={`btn btn-primary remove-btn`} onClick={this.remove}>
                        remove
                    </div>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
	return {
        updateCart: (cartItem, curQty) => dispatch(updateCart(cartItem, curQty))
	}
};


export default connect(null, mapDispatchToProps)(withError(RemoveButton));
